import type { PropsWithChildren } from 'react'

import styles from './MethodInfoBlock.module.scss'

interface MethodInfoBlockProps extends PropsWithChildren {
  title: string
  variant?: 'column' | 'row'
  className?: string
}

export function MethodInfoBlock({ title, variant = 'column', children, className }: MethodInfoBlockProps) {
  const contentClass = variant === 'row' ? styles.contentRow : styles.contentColumn

  return (
    <div className={`${styles.block} ${className ?? ''}`}>
      <div className={styles.title}>{title}</div>
      <div className={contentClass}>{children}</div>
    </div>
  )
}

// Export styles for use in child components
export { styles as methodInfoStyles }
